module.exports = __webpack_public_path__ + "img/hardyDownswingShoulders1.f188c611.png";